export default {
  RECAPTCHA_KEY: 'ws-recaptcha-key',
  HCAPTCHA_KEY: 'ws-hcaptcha-key',
  ACTION: 'action',
  SUCCESS_MESSAGE: 'success-message',
  EMAILS: 'emails',
  TIME_24HR: 'time-24hr',
};
